import { Paper, Typography } from "@mui/material";
import aboutImage from "../../assets/fallback/image7.jpg";
import styles from "./AboutUs.module.css";

const AboutUs = () => {
  return (
    <div className={styles.mainWrapper}>
      <div className="background">
        <img
          src={aboutImage}
          alt="Football"
          loading="lazy"
          decoding="async"
          style={{ width: "100%" }}
          className="background-image-desktop"
        />
      </div>
      <div className="white-paper">
        <Paper
          style={{
            width: "88%",
            position: "relative",
            top: "-15px",
            height: "100%",
            minHeight: "calc(100vh - 50vh - 80px)",
            padding: "20px 32px",
            boxShadow: "0 0 6px 0 rgba(0, 0, 0, 0.09)",
          }}
        >
          <Typography
            variant="h5"
            component="h2"
            style={{ color: "#01245a", marginBottom: "20px" }}
          >
            <strong>About Us</strong>
          </Typography>
          <Typography
            variant="body2"
            style={{
              color: "#797979",
              fontSize: "14px",
              textAlign: "justify",
              textAlignLast: "left",
              wordSpacing: "0px",
              letterSpacing: "0.2px",
              lineHeight: "1.6",
              hyphens: "auto",
            }}
          >
            WHS Sports Hub – Building India's Next Generation of Sports At WHS
            Sports Hub, we are creating future-ready spaces that inspire
            movement, connection, and community impact. We partner with
            institutions, campuses, and private venues across India to develop
            high-quality, multi-use infrastructure designed to promote active
            lifestyles and empower people of all ages. Our flexible models adapt
            to the needs of each partner — delivering dedicated access for
            students and professionals, while inviting broader community access
            through accessible, well-managed spaces. With streamlined
            operations, digital booking systems, and a commitment to long-term
            value creation, WHS Sports Hub goes beyond just building facilities
            — we build ecosystems that support wellness, growth, and engagement.
            Join us as we reimagine how India moves, plays, and thrives.
          </Typography>
        </Paper>
      </div>
      <div className={styles.footer}></div>
    </div>
  );
};

export default AboutUs;
